import React, { useState } from 'react';
import {TextField, Button, Box, Typography, Grid, CircularProgress, Breadcrumbs} from '@mui/material';
import api from '../../api';
import {Link, useNavigate} from 'react-router-dom';
import {NumericFormat} from "react-number-format";
import DidNotLoad from "../../components/DidNotLoad";  // Importando useNavigate

function RegisterPrinterPage() {
    const [name, setName] = useState('');
    const [brand, setBrand] = useState('');
    const [model, setModel] = useState('');
    const [consumption, setConsumption] = useState('');
    const [price, setPrice] = useState('');
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [resultErrors, setResultErrors] = useState({
        name: null,
        brand: null,
        model: null,
        price: null,
        consumption: null,
        has_errors: false
    });
    const [hasResponse, setHasResponse] = useState(false);
    const [didNotLoad, setDidNotLoad] = useState(false);

    const handleSubmit = (event) => {
        event.preventDefault();

        let hasError = false
        if (name === '') {
            hasError = true;
            setResultErrors((prevErrors) => ({
                ...prevErrors, // Mantém os valores existentes
                name: 'O nome da impressora é obrigatório para distinguir uma da outra.', // Atualiza o campo 'brand'
                has_errors: true, // Atualiza o indicador de erro
            }));
        }

        if (brand === '') {
            hasError = true;
            setResultErrors((prevErrors) => ({
                ...prevErrors, // Mantém os valores existentes
                brand: 'A marca do material é obrigatório.', // Atualiza o campo 'brand'
                has_errors: true, // Atualiza o indicador de erro
            }));
        }

        if (model === '') {
            hasError = true;
            setResultErrors((prevErrors) => ({
                ...prevErrors, // Mantém os valores existentes
                model: 'O modelo da impressora é obrigatório.', // Atualiza o campo 'brand'
                has_errors: true, // Atualiza o indicador de erro
            }));
        }

        if (hasError) {
            return;
        }

        if (isSubmitting) return; // Evita duplo clique
        setIsSubmitting(true); // Ativa o estado de loading

        const priceInCents = parseFloat(price.replace(/[^\d]/g, ''));
        const today = new Date().toISOString().slice(0, 10); // YYYY-MM-DD

        const newPrinter = {
            name,
            brand,
            model,
            power_consumption_watts: parseInt(consumption, 10),
            acquisition_value: parseInt(priceInCents, 10),
            acquisition_date: today,
            // Ainda não coletamos esse campo na tela; backend exige.
            hourly_printing_cost: 0,
        };

        api.post('printers', newPrinter)
            .then((response) => {
                setHasResponse(true);
                console.log('Impressora criada com sucesso:', response);
                navigate('/admin/printers');  // Redireciona de volta para a lista de impressoras
            })
            .catch((error) => {
                try {
                    const data = error.response.data;
                    setResultErrors({
                        ...data.errors,
                        has_errors: true,
                    });
                    setHasResponse(true);
                } catch (error) {
                    console.log(error);
                }
            })
            .finally(() => {
                setIsSubmitting(false); // Desativa o estado de loading
                if (!hasResponse) {
                    setDidNotLoad(true);
                }
            });
    };

    if (didNotLoad) {
        return <DidNotLoad/>
    }

    return (
        <div>
            <Breadcrumbs aria-label="breadcrumb">
                <Link color="inherit" onClick={() => navigate('/admin')} to={'/admin'}>
                    Dashboard
                </Link>
                <Link color="inherit" onClick={() => navigate('/admin/printers')} to={'/admin/printers'}>
                    Impressoras
                </Link>
                <Typography color="text.primary">Adicionando impressora</Typography>
            </Breadcrumbs>
            <br />
            <Typography variant="h4" gutterBottom>Adicionar Nova Impressora</Typography>
            <form onSubmit={handleSubmit}>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            label="Identificação (ex: Ender das luminárias)"
                            fullWidth
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                        {resultErrors.name && (
                            <div
                                className="text-danger mt-1"
                                style={{whiteSpace: 'pre-wrap', fontSize: '0.9rem'}}
                            >
                                {resultErrors.name}
                            </div>
                        )}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            label="Marca"
                            fullWidth
                            value={brand}
                            onChange={(e) => setBrand(e.target.value)}
                        />
                        {resultErrors.brand && (
                            <div
                                className="text-danger mt-1"
                                style={{whiteSpace: 'pre-wrap', fontSize: '0.9rem'}}
                            >
                                {resultErrors.brand}
                            </div>
                        )}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            label="Modelo"
                            fullWidth
                            value={model}
                            onChange={(e) => setModel(e.target.value)}
                        />
                        {resultErrors.model && (
                            <div
                                className="text-danger mt-1"
                                style={{whiteSpace: 'pre-wrap', fontSize: '0.9rem'}}
                            >
                                {resultErrors.model}
                            </div>
                        )}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            label="Consumo máximo (W)"
                            fullWidth
                            type="number"
                            value={consumption}
                            onChange={(e) => setConsumption(e.target.value)}
                            inputMode="numeric"
                        />
                        {resultErrors.consumption && (
                            <div
                                className="text-danger mt-1"
                                style={{whiteSpace: 'pre-wrap', fontSize: '0.9rem'}}
                            >
                                {resultErrors.consumption}
                            </div>
                        )}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <NumericFormat
                            label="Valor pago"
                            fullWidth
                            customInput={TextField}
                            value={price}
                            onValueChange={(values) => setPrice(values.value)} // Recebe o valor formatado
                            thousandSeparator="."
                            decimalSeparator=","
                            prefix="R$ "
                            decimalScale={2}
                            fixedDecimalScale
                            inputMode="numeric"
                        />
                        {resultErrors.price && (
                            <div
                                className="text-danger mt-1"
                                style={{whiteSpace: 'pre-wrap', fontSize: '0.9rem'}}
                            >
                                {resultErrors.price}
                            </div>
                        )}
                    </Grid>
                </Grid>
                <Box sx={{display: 'flex', justifyContent: 'flex-end', marginTop: 2}}>
                    <Button
                        variant="contained"
                        color="primary"
                        type="submit"
                        disabled={isSubmitting} // Desativa o botão durante o envio
                        startIcon={isSubmitting && <CircularProgress size={20} color="inherit" />}
                        fullWidth
                    >
                        {isSubmitting ? 'Cadastrando...' : 'Cadastrar Impressora'}
                    </Button>
                </Box>
            </form>
        </div>

    );
}

export default RegisterPrinterPage;
